import { render, staticRenderFns } from "./trial.vue?vue&type=template&id=233a0a5a&scoped=true&"
import script from "./trial.vue?vue&type=script&lang=js&"
export * from "./trial.vue?vue&type=script&lang=js&"
import style0 from "./trial.vue?vue&type=style&index=0&id=233a0a5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a0a5a",
  null
  
)

export default component.exports